import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { GenericPopUp } from "../../components/popup/genericPopUp";
import CustomDataGrid from "../../components/dms_common/CustomDataGrid"
import { primaryOrderRowsData, popupType, DownloadSingleReportConfig } from "../../types/types";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { downloadReport, task } from "../../services/reportService";
import dayjs, { Dayjs } from "dayjs";
import { ReactComponent as DownloadAllIcon } from "../../assets/image/svg/downloadAllWhite.svg";
import {
  Alert,
  Button,
  Snackbar,
  Stack,
  TextField,
} from "@mui/material";
import { PrimaryOrderConfig } from "./PrimaryOrderConfig";
import {
  getOrderList,
  getUTCDate,
} from "../../services/manageOrderService";
import { downloadReportAttributes, downloadReportRequestBody } from "../reports/types/types";
import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";
import "./PrimaryOrder.css";
import "../viewOrder/ViewOrder.css";
import "../manageBasket/ManageBasket.css";
import { Loader } from "../../components/loader/Loader";
import { getAccessToken } from "../../services/authenticationService";
import { filterData,  searchWithStatusFilter, updateDatesInLocalStorage } from "../../components/dms_common/DmsCommonServices";
import Header from "../../components/dms_common/Header";
import useSessionStorageDates from "../../components/dms_common/UseSessionStorageDates";
import { getConfigData } from "../../services/configurationService";
import { logEvent } from "firebase/analytics";
import { analytics, logLoadTrace } from "../../../src/firebase";
import { fetchSessionStorageFilter, safeStringify, truncateToTwoDecimals, updateSessionStorageFilter } from "../../components/dms_common/DmsUtils";
import { FilterKeys } from "../../types/types";
import { getDownloadSingleReportConfig } from "../secondaryOrder/ManageSecondaryOrderUtils";
import { isGapMoreThanNDays } from "../../utils/calenderUtils";
import ViewOrdersToggleFilter from "../../components/dms_common/ViewOrdersToggleFilter";
import { useLocation } from "react-router-dom";
import { sendSlackAlert, SlackChannel } from "../../services/slackService";

export type ViewOrdersToggleFilterType = "Manual Orders" | "ARS Orders";
export type ViewOrdersToggleFilterCountType = Record<ViewOrdersToggleFilterType, number>;

const PrimaryOrder = () => {
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const location = useLocation();
  const state = location.state as
    | {
        ars?: boolean;
      }
    | undefined;
  const startDateAtLastNDays = ConfigDictionary?.startDateAtLastNDays ?? 0
  const newStartDate = dayjs().subtract(startDateAtLastNDays, 'day')
  const { storedStartDate, storedEndDate, storeSessionStorageDates } = useSessionStorageDates("primaryOrder", newStartDate)
  const filterValue = fetchSessionStorageFilter(FilterKeys.PRIMARY_ViewPrimaryOrders) ?? "ALLORDERS";
  updateSessionStorageFilter(FilterKeys.PRIMARY_ViewAllGrn, "OPEN")

  const [viewOrderToggleFilters, setViewOrderToggleFilters] = useState<ViewOrdersToggleFilterType[]>(["Manual Orders", "ARS Orders"]);
  const [viewOrderToggleFiltersCount, setViewOrderToggleFiltersCount] = useState<ViewOrdersToggleFilterCountType>({"Manual Orders": 0, "ARS Orders": 0});
  const [selectedViewOrderToggleFilters, setSelectedViewOrderToggleFilters] =
    useState<ViewOrdersToggleFilterType>(() => {

      return (state?.ars && state?.ars)
        ? "ARS Orders"
        : "Manual Orders";
    });
  const [openGenericModal, setOpenGenericModal] = useState<boolean>(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState<string>("");
  const [startDate, setStartDate] = useState<Dayjs>(storedStartDate);
  const [endDate, setEndDate] = useState<Dayjs>(storedEndDate);
  const [data, setData] = useState<primaryOrderRowsData[]>([]);
  const [rows, setRows] = useState<primaryOrderRowsData[]>([]);
  const [actionButtons, setActionButtons] = useState<any[]>([]);
  const [loader, setLoader] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [grnStages,setGrnStages]=useState<any[]>([])
  const fetchLimitedOrderData = useRef<boolean>(false);
  const [downloadSingleReportConfig, setDownloadSingleReportConfig] =
      useState<DownloadSingleReportConfig | null>();
  const stagesRef = useRef<any>();
  const enableARSConfig = useRef<boolean>(false);
  const headerLabel = useRef<string>("View Primary Orders");
  const orderReportIdRef = useRef<string | null>(null);
  const singleOrderReportIdRef = useRef<string | null>(null);
  const [searchedValue, setSearchedValue] = useState<string>("");
  const [statusFilter, setStatusFilter] = useState<string>(filterValue);
  const [resetSearch, setResetSearch] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false); 
  const navbarParentLabel = "Purchase";
  const pageID = "PrimaryOrder";

  const openPopup = useCallback((message: string, type: popupType) => {
    setPopupType(type);
    setGenericMessage(message);
    setOpenGenericModal(true);
  }, []);

  const isStartDateIsGreaterThanEndDate = (startDate: dayjs.Dayjs, endDate: dayjs.Dayjs) => {
    const diff = endDate.diff(startDate);
    return diff < 0;
  };


  const validDateRange = ConfigDictionary.dateRangeConfig ?? 31;
  function canWeMakeRequest() {
    if (startDate && endDate && isGapMoreThanNDays(startDate, endDate, validDateRange)) {
      openPopup(`You can't select date range more than ${validDateRange} days!`, "Alert");
      return false;
    }
    if (startDate && endDate && isStartDateIsGreaterThanEndDate(startDate, endDate)) {
      openPopup("To Date should be greater than from date.", "Alert");
      return false;
    }
    updateDatesInLocalStorage(startDate, endDate, navbarParentLabel, pageID);
    return true;
  }

  const handleApply = async () => {
    if (isProcessing || !canWeMakeRequest()) return; // Prevent if already processing
    setIsProcessing(true);
    try {
      storeSessionStorageDates(startDate, endDate);
      const start = getUTCDate(startDate, "start");
      const end = getUTCDate(endDate, "end");
      await getAllOrderData(start, end);
      setStatusFilter(filterValue);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleClearAll = async () => {
    if (isProcessing) return; // Prevent if already processing
    setIsProcessing(true);
    try {
      const date = dayjs();
      storeSessionStorageDates(newStartDate, date);
      const start = getUTCDate(newStartDate, "start");
      const end = getUTCDate(date, "end");
      setStartDate(newStartDate);
      setEndDate(date);
      await getAllOrderData(start, end);
    } finally {
      setIsProcessing(false);
    }
  };

  const donwloadReportWithStatus = async (id: string) => {
    setSnackbarOpen(true);
    const res = await task(id);
    let data = res.data.features[0];
    if (data.status === "SUCCESS") {
      await download(id);
      setSnackbarOpen(false);
    } else if (data.status === "INPROGRESS") {
      await new Promise((resolve) => setTimeout(resolve, 2000)); 
      await donwloadReportWithStatus(id)
    } else {
      setSnackbarOpen(false);
      openPopup("Something went wrong", "Error");
    }
  };

  const download = async (id: string) => {
    let finalUrl = EnvironmentRegistry.getServerUrl();
    const link = document.createElement("a");
    link.href = `${finalUrl}` + "/v1/reports/" + id + "?access_token=" + getAccessToken();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const callMethod = async (requestBody: downloadReportRequestBody) => {
    if (Object.keys(requestBody).length > 0) {
      try {
        const response = await downloadReport(requestBody);
        await donwloadReportWithStatus(response.data.id);
      } catch (err) {
        console.error("Error inside callMethod:", err);
        throw err;
      }
    }
  };

  const getOrderActionButtons = async () => {
    try {
      const stages = ConfigDictionary?.primaryOrderTrackingStages;
      const grnStages =  ConfigDictionary?.grnStages;
      stages.unshift({
        id: "ALLORDERS",
        color: "#F0F3FF",
        dmsLabel: "All Orders",
        labelColor: "",
      });
      stagesRef.current = stages;
      setActionButtons(stages);
      setGrnStages(grnStages)
    } catch (error) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Fetching Order Stages - PrimaryOrder.tsx",
        `Failed to fetch order tracking or GRN stages. Error: ${(error as Error).message}`,
        safeStringify({ error })
      );
      console.error(error);
    }
  };
  useEffect(() => {
    const interval = setInterval(() => {
      getInitalTableData();
    }, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [startDate, endDate]);

  const getAllOrderData = async (startDate: string, endDate: string) => {
    setResetSearch(true); 
    setTimeout(() => setResetSearch(false), 0); 

    try {
      setLoader(true);
      const response = await getOrderList(startDate, endDate, "primary,subd", true, !(fetchLimitedOrderData.current));
      if (response.data.features.length > 0) {
        
        let responseArray: primaryOrderRowsData[] = [];
        response.data.features.forEach((item: any, index: any) => {
          const {
            id,
            orderNumber,
            creationTime,
            totalCaseQuantity,
            totalPieceQuantity,
            totalOtherUnitQuantity,
            netAmount,
            status,
            invoiceNumber,
            grnStatus,
            source
          } = item;

          const truncateNetAmount= truncateToTwoDecimals(netAmount)
          responseArray.push({
            id,
            orderNumber,
            creationTime,
            totalCaseQuantity,
            totalPieceQuantity,
            totalOtherUnitQuantity,
            netAmount : truncateNetAmount,
            status,
            invoiceNumber,
            grnStatus,
            source,
            showEyeIcon: (source?.toLowerCase() === "ars" ? status?.toLowerCase() !== "pending" : true),
            hideGRNStatusPendingOrder: (status ==="PENDING" || status === "CONFIRMED")
          });
        });
        setRows(responseArray);
        setData(responseArray);
      } else {
        setRows([]);
        setData([]);
      }
    } catch (error) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Fetching Orders - PrimaryOrder.tsx",
        `Failed to fetch order list for date range ${startDate} to ${endDate}. Error: ${(error as Error).message}`,
        safeStringify({ error, startDate, endDate, statusFilter, searchedValue })
      );
      setRows([]);
      openPopup("Something went wrong", "Error");
    } finally {
      setLoader(false);
    }
  };

  const handleSearchValueChange = (newValue: string) => {
    setSearchedValue(newValue);
  };

  const handleStatusFilterChange = (newFilter: string) => {
    setStatusFilter(newFilter);
    updateSessionStorageFilter(FilterKeys.PRIMARY_ViewPrimaryOrders , newFilter);
  };

  const filteredData = useMemo(() => {
    let toggleFilteredData = data?.filter(s => selectedViewOrderToggleFilters === "ARS Orders" ? "ars" === s?.source?.toLowerCase() : "ars" !== s?.source?.toLowerCase());
    const ars_count = selectedViewOrderToggleFilters === "ARS Orders" ? toggleFilteredData?.length : data?.length- toggleFilteredData?.length;
    setViewOrderToggleFiltersCount({"Manual Orders": (data?.length - ars_count), "ARS Orders": ars_count});
    const res = filterData(
      toggleFilteredData,
      searchedValue.toLowerCase(),
      searchWithStatusFilter,
      statusFilter
    );
    return res;
  }, [searchedValue, statusFilter, data, selectedViewOrderToggleFilters]);

  const fetchRequiredConfigs = async () => {
      try {
        const primaryOrderReportIdConfig = await getConfigData(
                "dms_configuration",
                "primaryOrderReportNameId"
              );
        const enableARSConfigV = await getConfigData(
                "dms_configuration",
                "enableARSConfig"
              );
        const viewPrimaryOrdersHeaderLabel = await getConfigData(
                "dms_configuration",
                "viewPrimaryOrdersHeaderLabel"
              );
        const fetchLimitedOrderDataConfig = await getConfigData(
          "dms_configuration",
          "fetchLimitedOrderData"
        );
        const primaryOrderReportId = primaryOrderReportIdConfig[0]?.configValue ?? "PrimaryOrderReport";
        fetchLimitedOrderData.current = fetchLimitedOrderDataConfig?.[0]?.configValue ?? false;
        orderReportIdRef.current = primaryOrderReportId;
        headerLabel.current = viewPrimaryOrdersHeaderLabel?.[0]?.configValue ?? headerLabel.current;
        enableARSConfig.current = enableARSConfigV[0]?.configValue ?? false;
        setDownloadSingleReportConfig(getDownloadSingleReportConfig(primaryOrderReportId));
      } catch (e) {
        await sendSlackAlert(
          SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
          "Error Fetching Configurations - PrimaryOrder.tsx",
          `Failed to fetch configuration data (e.g., primaryOrderReportId, enableARSConfig). Error: ${(e as Error).message}`,
          safeStringify({ e, configKeys: ["primaryOrderReportId", "enableARSConfig", "viewPrimaryOrdersHeaderLabel"] })
        );
        console.error("Error while fetching configs", e);
      }
    };

  useEffect(() => {
    if(searchedValue){
      logEvent(analytics, "search_primary_order", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "search_query" : searchedValue,
        "result_count": filteredData.length
      });
      console.log("search-primary",filteredData.length,searchedValue)
      }
  },[searchedValue]);


  useEffect(() => {
    if(!loader) {
      logEvent(analytics, "primary_order_list_viewed", {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "total_orders_displayed": filteredData.length
      });
      console.log("primary-order-list",filteredData.length)
    }
  },[filteredData,loader,statusFilter]);

  useEffect(() => {
    setRows(filteredData);
  }, [filteredData]);

  useEffect(()=>{
    if (selectedViewOrderToggleFilters === "ARS Orders"){
      setDownloadSingleReportConfig(getDownloadSingleReportConfig(orderReportIdRef.current ?? "PrimaryOrderReport", true))
    } else{
      setDownloadSingleReportConfig(getDownloadSingleReportConfig(orderReportIdRef.current ?? "PrimaryOrderReport", false))
    }
  }, [selectedViewOrderToggleFilters])



  const handleDownloadAll = async () => {
    if (isProcessing) return; // Prevent if already processing
    const isArs = selectedViewOrderToggleFilters === "ARS Orders"
    setIsProcessing(true);
    try {
      if (orderReportIdRef.current === null) {
        openPopup(
          "Order Report ID in config is invalid. Enter correct ID in config to download report",
          "Error"
        );
        return;
      }

      let filter;
      if (isArs){
        filter = {
          filters: [
            {
              key: "type",
              value: "primary",
            },
            {
              key: "source",
              value: "ars"
            }
          ],
          operator: "and",
        };
      } else{
        filter = {
          filters: [
            {
              key: "type",
              value: "primary",
            },
          ],
          operator: "and",
        };
      }

      const attributes: downloadReportAttributes = {
        name: orderReportIdRef.current,
        format: "xlsx",
        filter: filter,
        loggedInUserName: JSON.parse(localStorage.authContext).user.loginId,
        fromDate: moment(startDate.toISOString()).format("YYYY-MM-DD 00:00:00"),
        toDate: moment(endDate.toISOString()).format("YYYY-MM-DD 23:59:59"),
      };

      const requestBody: downloadReportRequestBody = {
        attributes,
        lob: EnvironmentRegistry.getCurrentLob() ?? "",
      };
      const startTime = window.performance.now();
      
      await callMethod(requestBody);
      
      const endTime = window.performance.now();
      console.log(endTime);
      logEvent(analytics, `${isArs ? "ars_orders_report_downloaded" : "primary_orders_report_downloaded"}`, {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "download_format": "xlsx",
        "download_time": (endTime - startTime),
      });
    } catch (err) {
      await sendSlackAlert(
        SlackChannel.DMS_PRIMARY_UI_NOTIFICATION,
        "Error Downloading All Reports - PrimaryOrder.tsx",
        `Failed to download all reports. Error: ${(err as Error).message}`,
        safeStringify({ err, startDate, endDate, selectedViewOrderToggleFilters, orderReportId: orderReportIdRef.current })
      );
      console.error("Error in downloading all reports");
      logEvent(analytics, `${isArs ? "ars_orders_report_download_failed" : "primary_orders_report_download_failed"}`, {
        "distributor_id": JSON.parse(localStorage.authContext).user.loginId,
        "error_reason": err
      });
      openPopup("Something went wrong", "Error");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarOpen(false);
  };

  const getInitalTableData = async () => {
    if (isProcessing) return; // Prevent if already processing
    setIsProcessing(true);
    try {
      setEndDate(endDate);
      setStartDate(startDate);
      const start = getUTCDate(startDate, "start");
      const end = getUTCDate(endDate, "end");
      await getAllOrderData(start, end);
    } finally {
      setIsProcessing(false);
    }
  };


  const init = async () => {
    if (isProcessing) return; // Prevent if already processing
    setIsProcessing(true);
    try {
      setLoader(true);
      await Promise.allSettled([
        fetchRequiredConfigs(),
        getOrderActionButtons(),
        getInitalTableData(),
      ]);
    } finally {
      setLoader(false);
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    logLoadTrace(init,"primary_orders_load_time");
  }, []);

  const updateViewOrderToggleFilterSelection = (option: ViewOrdersToggleFilterType) => {
    setSelectedViewOrderToggleFilters(option);
  }

  const loadingData = loader || !grnStages.length || !stagesRef.current.length;

  return (
    <div className="primary-order-parent">
      <GenericPopUp
        message={genericMessage}
        type={popupType}
        openGenericModal={openGenericModal}
        setOpenGenericModal={setOpenGenericModal}
      />
      <Snackbar
        open={snackbarOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="info"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Your report will be downloaded shortly.
        </Alert>
      </Snackbar>

       <Header
        title={headerLabel.current} 
        searchFunction={loader ? () => { } : handleSearchValueChange} 
        onRefresh={init}
        resetSearch={resetSearch}
      />

      <div className="primary-order-filter-bar">
        <div className="primary-order-date-action-btn-container">
          <Stack spacing={2} direction={"row"}>
 
            <LocalizationProvider dateAdapter={AdapterDayjs} className="dateEnter">
  <DatePicker
    label="From Date"
    inputFormat="DD-MM-YYYY"
    value={startDate}
    maxDate={dayjs()}
    onChange={(value) => {
      if (value) {
        setStartDate(value);
      }
    }}
    renderInput={(props) => <TextField {...props} inputProps={{
      ...props.inputProps,
      readOnly: true,
    }} disabled size="small" />}
  />
</LocalizationProvider>

<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    label="To Date"
    inputFormat="DD-MM-YYYY"
    value={endDate}
    maxDate={dayjs()}
    onChange={(value) => {
      if (value) {
        setEndDate(value);
      }
    }}
    renderInput={(props) => <TextField {...props} inputProps={{
      ...props.inputProps,
      readOnly: true,
    }} disabled size="small" />}
  />
</LocalizationProvider>

           

          </Stack>
          <Button variant="contained" sx={{ backgroundColor: "#237C9D", borderRadius:"6px",textTransform: "none",boxShadow: "none",  }} onClick={handleApply}>
            Apply
          </Button>
          <Button
            variant="outlined"
            sx={{ backgroundColor: "#F0FBFF", borderRadius:"6px", textTransform: "none",boxShadow: "none"}}
            onClick={handleClearAll}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              minWidth: "170px",
              backgroundColor: "var(--dashboard-theme-color)",
              ":hover": {
                background: "var(--dashboard-theme-color)",
              },
               borderRadius:"6px",
               boxShadow: "none",
            }}
            onClick={handleDownloadAll}
          >
             <DownloadAllIcon style={{ marginRight: "6px" }} />
            Download All
          </Button>
        </div>
        <div className="primary-order-filter-container">
          <InputLabel id="primary-filter-dropdown" sx={{color:"#B2B2B2",fontSize:"15px"}}>Filter:</InputLabel>
          <FormControl size="small" sx={{ width: "70%" }}>
            <Select
              labelId="primary-filter-dropdown"
              value={statusFilter}
              onChange={(e) => {
                handleStatusFilterChange(e.target.value);
              }}
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#DEDEDE'
                },
              '& .MuiSelect-select': {
        color: '#5C5C5C',      
        fontSize: '14px',      
        fontWeight: 500,       
      },
              }}
            >
              {actionButtons.map((option) => (
                <MenuItem key={option.id} value={option.id} sx={{
                  color: '#5C5C5C',      
                  fontSize: '14px',      
                  fontWeight: 500,       
                }}>
                  {option.dmsLabel}
                </MenuItem>
              ))}
            </Select>

          </FormControl>
        </div>
      </div>

      {enableARSConfig.current && (
        <ViewOrdersToggleFilter
        filterOptions={viewOrderToggleFilters}
        countRecord={viewOrderToggleFiltersCount}
        updateFilterSelection={updateViewOrderToggleFilterSelection}
        selectedFilters={selectedViewOrderToggleFilters}
      />)}

      {loader? (
        <Loader  sx={{ position: "absolute", top: "55%" }}/>
      ) : (
          <CustomDataGrid
            rows={rows}
            columnsMetaData={PrimaryOrderConfig}
            orderStatusConfig={stagesRef.current}
            grnStatusConfig={grnStages}
            downloadSingleReportConfig={downloadSingleReportConfig}
            redirectUrl="/purchase/viewPrimaryOrders/viewOrder/"
            viewIcon={"eyeIcon"}
            openButtonNavigateUrl="purchase/viewPrimaryOrders"
            tableWidth={0.73}
            height="98"
            isPrimaryOrder={true}
            isPrimaryModuleReport={true}
          />
      )}
    </div>
  );
};
export default PrimaryOrder;
